module.exports = {"test":"test"}


//////////////////
// WEBPACK FOOTER
// ./src/mixins/staticConf/dcm.json
// module id = yui2
// module chunks = 0